import getOrganizations from '../../modules/organizations/actions/getOrganizations';

export default (store) => ({
  path: 'organizations',
  getComponent(nextState, callback) {
    require.ensure([], (require) => callback(null, require('./containers/ListContainer').default));
  },
  onEnter() {
    store.dispatch(getOrganizations());
  }
});



// WEBPACK FOOTER //
// ./src/routes/organizations/index.js